/* eslint-disable no-case-declarations */
import { AxiosRequestConfig } from 'axios'
import { call, ForkEffect, put, select, takeLatest } from 'redux-saga/effects'

import {
  IError,
  SendToGeneratorYield,
  SendToGeneratorReturn,
  SEND_TO,
  SEND_TO_FAIL,
  SEND_TO_LOGIN_FALLBACK,
  SEND_TO_SUCCESS,
  ISendTo,
} from '.'
import { ApiResponse } from '../../interfaces'
import sendToService from '../../services/sendTo'
import sendToLoginFallbackService from '../../services/sendToLoginFallback'
import { RootStore } from '../store'

export function* sendToGenerator({
  payload: { userId, ...login },
}: ISendTo): Generator<SendToGeneratorYield, void, SendToGeneratorReturn> {
  const middleware: AxiosRequestConfig = yield select(
    (state: RootStore) => state.configuration.data?.extensions.sendToMiddleware
  )

  const response = yield call(sendToService, userId, login, middleware)
  const { data, status, success } = response as ApiResponse<string | IError>

  if (success) {
    const payload = data as string

    yield put({
      type: SEND_TO_SUCCESS,
      payload,
    })
  } else {
    const { message, details } = data as IError

    yield put({
      type: SEND_TO_FAIL,
      payload: {
        message,
        details,
        status,
      },
    })
  }
}

function* sendToLoginFallbackGenerator({
  payload: { userId },
}: ISendTo): Generator<SendToGeneratorYield, void, SendToGeneratorReturn> {
  const middleware: AxiosRequestConfig = yield select(
    (state: RootStore) => state.configuration.data?.extensions.sendToLoginFallbackMiddleware
  )

  const response = yield call(sendToLoginFallbackService, userId, middleware)
  const { data, status, success } = response as ApiResponse<string | IError>

  if (success) {
    const response = data as string

    yield put({
      type: SEND_TO_SUCCESS,
      payload: response,
    })
  } else {
    const { message, details } = data as IError

    yield put({
      type: SEND_TO_FAIL,
      payload: {
        message,
        details,
        status,
      },
    })
  }
}

export function* sendToSaga(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(SEND_TO, sendToGenerator)
}

export function* sendToLoginFallbackSaga(): Generator<ForkEffect<never>, void, unknown> {
  yield takeLatest(SEND_TO_LOGIN_FALLBACK, sendToLoginFallbackGenerator)
}
